import React, { Component } from "react";
import Chart from "react-apexcharts";

export default class CorrelationChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [625741, 77642],
      options: {
        labels: ["Total Alarms", "Correlated"],
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              size: "60%",
              labels: {
                show: false,
                // name: {
                //   ...
                // },
                // value: {
                //   ...
                // }
              },
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (value, { seriesIndex, dataPointIndex, w }) {
            console.log(w);
            console.log(value);
            let name = w.config.labels[seriesIndex];
            let numberValue = w.config.series[seriesIndex];
            return (
              name + ":  " + numberValue + " (" + value.toFixed(2) + "%" + ")"
            );
          },
          style: {
            colors: ["#656161"],
            fontSize: "12px",
            fontWeight: 700,
          },
          background: {
            enabled: true,
            foreColor: "#FFFFFF",
            borderRadius: 2,
            padding: 4,
            opacity: 0.9,
            borderWidth: 1,
            borderColor: "#FFFFFF",
          },
          offsetY: -20,
        },
        colors: ["#71B0DF", "#FBBA2B"],
      },
    };
  }
  render() {
    return (
      <div className="donut">
        <Chart
          options={this.state.options}
          series={this.state.series}
          type="donut"
          width={"100%"}
          height={200}
        />
      </div>
    );
  }
}
